import { Text, Flex } from '@frontend/components';

type NotificationDateProps = { date: string };

const NotificationDate = ({ date }: NotificationDateProps) => (
  <Flex justifyContent="center" flexDirection="column">
    <Text color="feature.secondary" size="sm">
      {date}
    </Text>
  </Flex>
);

export default NotificationDate;
